var _path, _path2, _path3, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmsTextNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0381 14.5594C14.7579 14.5594 14.5307 14.787 14.5307 15.0678V15.9152H3.53722C3.25702 15.9152 3.02982 16.1429 3.02982 16.4237C3.02982 16.7045 3.25702 16.9322 3.53722 16.9322H14.5307V19.1357C14.5307 19.6031 14.1515 19.983 13.6851 19.983H2.86038C2.39398 19.983 2.0148 19.603 2.0148 19.1357V2.86434C2.0148 2.39695 2.39399 2.01696 2.86038 2.01696H15.0379C15.3181 2.01696 15.5453 1.78927 15.5453 1.50848C15.5453 1.22768 15.3181 1 15.0379 1H2.86038C1.83428 1 1 1.83629 1 2.86434V19.1357C1 20.1639 1.83451 21 2.86038 21H13.6851C14.7112 21 15.5455 20.1637 15.5455 19.1357V15.0678C15.5455 14.787 15.3183 14.5594 15.0381 14.5594Z",
    fill: "#013590",
    stroke: "#013590",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1626 3.12112H9.80754C8.79402 3.12112 7.96997 3.95429 7.96997 4.97851V10.382C7.96997 11.4064 8.79425 12.2394 9.80754 12.2394H10.6428V14.4346C10.6428 14.6398 10.7647 14.8245 10.952 14.903C11.1292 14.9774 11.3567 14.9358 11.4981 14.7929L14.0243 12.2396H19.1627C20.1762 12.2396 21.0003 11.4064 21.0003 10.3822V4.97871C21.0003 3.95403 20.1762 3.12109 19.1627 3.12109L19.1626 3.12112ZM19.9978 10.3817C19.9978 10.8474 19.6233 11.226 19.1626 11.226H13.8168C13.6839 11.226 13.5564 11.2793 13.4624 11.3743L11.645 13.2116V11.7328C11.645 11.453 11.4206 11.2262 11.1438 11.2262H9.80745C9.34677 11.2262 8.97223 10.8476 8.97223 10.3819V4.97848C8.97223 4.51283 9.34677 4.13426 9.80745 4.13426H19.1625C19.6232 4.13426 19.9977 4.51284 19.9977 4.97848L19.9978 10.3817Z",
    fill: "#013590",
    stroke: "#013590",
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87906 18.4243C8.87906 18.6753 8.67553 18.8788 8.42452 18.8788C8.1735 18.8788 7.96997 18.6753 7.96997 18.4243C7.96997 18.1733 8.1735 17.9697 8.42452 17.9697C8.67553 17.9697 8.87906 18.1733 8.87906 18.4243Z",
    fill: "#013590",
    stroke: "#013590",
    strokeWidth: 0.4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 6.5,
    x2: 17.5,
    y2: 6.5,
    stroke: "#013590",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 8.5,
    x2: 17.5,
    y2: 8.5,
    stroke: "#013590",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsTextNotification);
export default __webpack_public_path__ + "static/media/sms-text-notification.60f998c1cf2201117bcd5713407fe252.svg";
export { ForwardRef as ReactComponent };